import API from '@/utils/api';
import { Button, Text, toast, Topbar } from '@bsf/force-ui';
import { __ } from '@wordpress/i18n';
import { Rocket, X } from 'lucide-react';

const { icon, iconURL } = gettingStartedVars || {};

const Header = () => {
	const handleDismissSetup = () => {
		API.dismissSetupWizard()
			.then( ( response ) => {
				if ( response.success ) {
					window.location.href = gettingStartedVars.adminDashboardURL;
				}
			} )
			.catch( ( error ) => {
				toast.error(
					__( 'Setup dismissal failed!', 'getting-started' ),
					{
						description:
							error?.message ||
							__( 'Failed to dismiss setup.', 'getting-started' ),
					}
				);
			} );
	};

	return (
		<Topbar className="sticky top-0 sm:top-[46px] md:top-[32px] p-0 bg-background-primary gap-0 min-h-12 sm:min-h-14 shadow-sm z-20">
			<Topbar.Left className="p-3 sm:p-4">
				<Topbar.Item className="w-5 h-5 sm:w-6 sm:h-6">
					<span className="sr-only">
						{ __( 'Finish Setup Icon', 'getting-started' ) }
					</span>

					{ iconURL && (
						<img
							src={ iconURL }
							alt={ __( 'Finish Setup', 'getting-started' ) }
							className="w-5 h-5 sm:w-6 sm:h-6"
						/>
					) }

					{ ! iconURL && icon && (
						<span
							className="[&>svg]:w-5 [&>svg]:h-5 sm:[&>svg]:w-6 sm:[&>svg]:h-6"
							dangerouslySetInnerHTML={ { __html: icon } }
						></span>
					) }

					{ /* Fallback icon if no icon is provided */ }
					{ ! iconURL && ! icon && <Rocket /> }
				</Topbar.Item>
			</Topbar.Left>
			<Topbar.Middle align="left" className="h-full">
				<Topbar.Item className="gap-3">
					<Text
						size={ 14 }
						color="primary"
						weight={ 500 }
						className="content-center no-underline relative h-full py-3 sm:py-4.5 px-1 m-0 bg-transparent outline-none shadow-none border-0 focus:outline-none cursor-pointer text-xs sm:text-sm"
					>
						{ __( 'Finish Setup', 'getting-started' ) }
						<span className="absolute bottom-0 left-0 w-full h-px bg-gs-primary" />
					</Text>
				</Topbar.Item>
			</Topbar.Middle>
			<Topbar.Right className="p-3 sm:p-4">
				<Topbar.Item>
					<Button
						size="xs"
						variant="link"
						className="w-full rounded-sm text-black hover:text-gray-800 hover:no-underline"
						onClick={ handleDismissSetup }
						icon={ <X /> }
						iconPosition="right"
					>
						{ __( 'Dismiss Setup', 'getting-started' ) }
					</Button>
				</Topbar.Item>
			</Topbar.Right>
		</Topbar>
	);
};

export default Header;
